type CourseProgressSection = {
  score?: number | null;
  time_accumulator?: number | null;
  completion_date?: string | null;
};

/**
 * A section joins the course average once it has been scored. Sections are
 * recorded in the course progress the moment the learner opens them, so an
 * unscored entry is the section being worked on right now — counting it as 0
 * dropped the course score the instant a new section was started.
 */
export function isScoredCourseSection(section: CourseProgressSection): boolean {
  return typeof section.score === 'number' || !!section.completion_date;
}

export function calculateCourseAverageScore(
  sections?: CourseProgressSection[] | null,
): number {
  if (!Array.isArray(sections) || sections.length === 0) return 0;

  const scoredSections = sections.filter(isScoredCourseSection);
  if (scoredSections.length === 0) return 0;

  const total = scoredSections.reduce(
    (acc, section) => acc + (section.score ?? 0),
    0,
  );
  return Math.round(total / scoredSections.length);
}

export function calculateCourseAccumulatedTime(
  sections?: CourseProgressSection[] | null,
): number {
  if (!Array.isArray(sections) || sections.length === 0) return 0;

  return sections.reduce(
    (acc, section) => acc + (section.time_accumulator ?? 0),
    0,
  );
}
